import api from './api';

export interface PDCAMetrics {
  phaseDistribution: Array<{
    _id: string;
    count: number;
    avgProgress: number;
  }>;
  avgCycleTime: number;
}

const pdcaService = {
  // Transition task to new phase
  transitionPhase: async (taskId: string, phase: 'plan' | 'do' | 'check' | 'act') => {
    const response = await api.put(`/pdca/${taskId}/transition`, { phase });
    return response.data;
  },

  // Add activity log entry
  addActivity: async (taskId: string, activity: string) => {
    const response = await api.post(`/pdca/${taskId}/activity`, { activity });
    return response.data;
  },

  // Add blocker
  addBlocker: async (taskId: string, description: string) => {
    const response = await api.post(`/pdca/${taskId}/blocker`, { description });
    return response.data;
  },

  // Resolve blocker
  resolveBlocker: async (taskId: string, blockerIndex: number, resolution: string) => {
    const response = await api.put(`/pdca/${taskId}/blocker/${blockerIndex}`, { resolution });
    return response.data;
  },

  // Update progress percentage
  updateProgress: async (taskId: string, progressPercentage: number) => {
    const response = await api.put(`/pdca/${taskId}/progress`, { progressPercentage });
    return response.data;
  },

  // Get PDCA metrics
  getMetrics: async (): Promise<PDCAMetrics> => {
    const response = await api.get('/pdca/metrics');
    return response.data.data;
  },

  // Get tasks by phase
  getTasksByPhase: async (phase: 'plan' | 'do' | 'check' | 'act') => {
    const response = await api.get(`/pdca/phase/${phase}`);
    return response.data;
  },

  // Add lesson learned
  addLessonLearned: async (
    taskId: string,
    category: 'success' | 'challenge' | 'improvement',
    description: string,
    actionItem?: string
  ) => {
    const response = await api.post(`/pdca/${taskId}/lesson`, {
      category,
      description,
      actionItem
    });
    return response.data;
  },

  // Convert task to template
  convertToTemplate: async (taskId: string, templateCategory?: string) => {
    const response = await api.put(`/pdca/${taskId}/template`, { templateCategory });
    return response.data;
  }
};

export default pdcaService;
